/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import classes from './ItemRow.scss';
import { TRACK_CLICK_SIZE_GUIDE } from '../../../../src/web/utils/dataLayer';
import useEventTrigger from '../../../../modules/react/hooks/useEventTrigger';

const ItemRow = ({ item, onChange, value }) => {
  const { id, name, size } = item;
  const { addEvent } = useEventTrigger();


  const handleChange = (newValue) => {
    onChange(id, newValue);
  };

  const handleInputChange = (event) => {
    handleChange(event.target.value);
  };

  const getAnalyticsPayload = () => ({
    eventLocation: 'sizeCalculator',
    timeStamp: Date.now(),
  });

  const handleTrackAnalytics = (actionName) => {
    const defaultPayload = getAnalyticsPayload();
    const analyticsPayload = {
      actionType: actionName,
      name,
      category: item.category,
      size,
      ...defaultPayload,
    };
    addEvent(TRACK_CLICK_SIZE_GUIDE, analyticsPayload, 'click');
  };

  const handleClickAdd = () => {
    handleChange((value || 0) + 1);
    handleTrackAnalytics('add');
  };

  const handleClickSubtract = () => {
    handleChange((value || 0) - 1);
    handleTrackAnalytics('subtract');
  };


  return (
    <div className={classes.row}>
      <div className={classes.name}>
        {name}
      </div>
      <div className={classes.size}>
        approximately {size} cubic feet
      </div>
      <div className={classes.control}>
        <i
          className={[
            'fa',
            'fa-plus-circle',
            'color-primary-foreground',
            'color-secondary-foreground-hover',
          ].join(' ')}
          unselectable="on"
          onClick={handleClickAdd}
        />
        <i
          className={[
            'fa',
            'fa-minus-circle',
            'color-primary-foreground',
            'color-secondary-foreground-hover',
          ].join(' ')}
          unselectable="on"
          onClick={handleClickSubtract}
        />
        <Form.Control
          type="text"
          value={value || ''}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};

ItemRow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    category: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
};

ItemRow.defaultProps = {
  value: undefined,
};

export default React.memo(ItemRow);
